var forms = (function($) {
	var _bind = function() {
		var $el = $('#gform_wrapper_7 #field_7_9 input[type="checkbox"]');

		$el.each(function() {
			if ($(this).val() === 'Request pricing') {
				$(this).attr('id', 'im_interested_in_0');
				$(this).parent().find('label').attr('for', 'im_interested_in_0');
			} else if ($(this).val() === 'Request a demo') {
				$(this).attr('id', 'im_interested_in_1');
				$(this).parent().find('label').attr('for', 'im_interested_in_1');
			} else if ($(this).val() === 'Start a trial') {
				$(this).attr('id', 'im_interested_in_2');
				$(this).parent().find('label').attr('for', 'im_interested_in_2');
			} else if ($(this).val() === 'Careers') {
				$(this).attr('id', 'im_interested_in_3');
				$(this).parent().find('label').attr('for', 'im_interested_in_3');
			} else if ($(this).val() === 'Agency Information') {
				$(this).attr('id', 'im_interested_in_4');
				$(this).parent().find('label').attr('for', 'im_interested_in_4');
			} else if ($(this).val() === 'General Information') {
				$(this).attr('id', 'im_interested_in_5');
				$(this).parent().find('label').attr('for', 'im_interested_in_5');
			}
		});

		$el.change(function() {
			var $checked = $el.filter(':checked');
			var $lead = $('#input_7_10');

			if ($checked.length === 0 || $checked.length > 1) {
				$lead.val('Website - Enquiry');
			} else {
				var _checked = $checked.val();

				switch(_checked) {
				    case 'Request pricing':
				        $lead.val('Website - Pricing Request');
				        break;
				    case 'Request a demo':
				        $lead.val('Website - Demo Request');
				        break;
				    case 'Start a trial':
				        $lead.val('Website - Start a Trial');
				        break;
				    case 'Agency Information':
				        $lead.val('Website - Agency Information');
				        break;
				    case 'Careers':
				        $lead.val('Careers');
				        break;
				    default:
				        $lead.val('Website - Enquiry');
				}
			}
		});

        var $contactCountry = $('#input_7_13');
        if($contactCountry.length) {
            $contactCountry.val($('body').data('country-label'));
        };

        var $demoCountry = $('#input_8_11');
        if($demoCountry.length) {
            $demoCountry.val($('body').data('country-label'));
        }

        var $ticketCountry = $('#input_9_11');
        if($ticketCountry.length) {
            $ticketCountry.val($('body').data('country-label'));
        }
	};

	function init() {
		_bind();
	}

	return {
		init:init
	};
}(jQuery)); 

jQuery(document).ready(function($) {
	forms.init();
}).on('gform_confirmation_loaded', function(event, form_id) {
    $("html,body").animate({ scrollTop: $('.form').offset().top - 150 }, "fast");
});
